import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { switch_view } from '../../scene';
import { must_view_down_negative_direction } from '../../utility';
import view_z_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/view_z.svg';
import { img } from '@phi/components';
import ViewZTooltip from './ViewZTooltip';

export const ViewZIcon = view_z_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.coming_soon;
        },

        coming_soon() {
            return !this.state.loaded || this.state.tut_stage < 1;
        },

        alt() {
            return 'Switch view down the Z axis';
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                switch_view('z', must_view_down_negative_direction('z'));
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            active: false,
            id: 'view-z-button',
            tippy: 'top',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(view_z_svg, this.alt),
            tooltip: ViewZTooltip,
        });
    }
});
